export function useSortByRow<T extends { row: string | number }>(
  data: T[],
): T[] {
  return data.sort((a, b) => Number(a.row) - Number(b.row));
}
